import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const getFormatedDate = (currentDate) => {
  return currentDate.split('/').reverse().join('-');
};

export const safeParseDate = (dateStr) => {
  if (!dateStr) return null;
  const dotNetMatch = String(dateStr).match(/\/Date\((\d+)\)\//);
  if (dotNetMatch) return new Date(Number(dotNetMatch[1]));
  const parsed = parseISO(dateStr);
  if (!Number.isNaN(parsed.getTime())) return parsed;
  const fallback = new Date(dateStr);
  if (!Number.isNaN(fallback.getTime())) return fallback;
  return null;
};

export const formatDateTime = (dateStr) => {
  const parsed = safeParseDate(dateStr);
  if (!parsed) return '';
  try {
    return format(parsed, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
  } catch {
    return '';
  }
};

export const getNotificationTime = (notification) => {
  if (notification.Lida !== null)
    return `Lida em ${formatDateTime(notification.Lida)}`;
  if (notification.Recebida)
    return `Recebida em ${formatDateTime(notification.Recebida)}`;
  return '';
};
